import React from 'react';
import { Button } from '../../components/ui';
import { useConfig } from '../../contexts/ConfigContext';

const SignInPage: React.FC = () => {
  const { config } = useConfig();

  const handleSignIn = () => {
    // Redirect to the Cognito login endpoint
    window.location.href = `${config.api.apiUrl}/auth/cognito/login`;
  };

  return (
    <>
      <h1 className="page-heading">Sign in to your account</h1>
      <p>You can access your account by signing in with one of the options below.</p>
      <div className="mt-8">
        <Button type="button" className="w-full" onClick={handleSignIn} outline>
          Sign in with Cognito
        </Button>
      </div>
    </>
  );
};

export default SignInPage;
